import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { ClientModel } from "../../models/client/client.model";
import { ClientRepository } from "../../repositories/client.repository";

export class StatusClientUseCase implements UseCase<{ Id: string}, ClientModel> {
    constructor(private ClientRepository: ClientRepository) { }
    execute(
        params: {Id: string},
    ): Observable<ClientModel> {
        return this.ClientRepository.statusClient(params);
    }
}
